import { Reducer, Action } from "redux";
import { IDashboardServiceState, KnownAction, GET_DASHBOARD_SERVICES, SHOW_LOADER, GET_USER_DASHBOARD_STATUS } from "./types";
import { REQUEST_ALL_TU_SEVICES, RECEIVE_ALL_TU_SEVICES, ITUServiceState, TUServiceAction } from "./types";

export const reducer: Reducer<IDashboardServiceState> = (state: IDashboardServiceState | undefined, incomingAction: Action): IDashboardServiceState => {
    if (state === undefined) {
        return { dashboardServices: [], isLoading: false, userDashboardstatus:"" };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case GET_DASHBOARD_SERVICES:
            return {
                ...state,
                dashboardServices: action.dashboardServices,
            };
        case SHOW_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case GET_USER_DASHBOARD_STATUS:
            return {
                ...state,
                userDashboardstatus: action.userDashboardstatus,
            };
        default:
            return state;
    }
};

const initialTuServicesState: ITUServiceState = {
    loadingServices: false,
}
export const tuServicesReducer: Reducer<ITUServiceState> = (state: ITUServiceState | undefined = initialTuServicesState, incomingAction: Action): ITUServiceState => {
    if (state === undefined) {
        return initialTuServicesState;
    }
    const action = incomingAction as TUServiceAction;

    switch (action.type) {
        case REQUEST_ALL_TU_SEVICES:
            return { ...state, loadingServices: true };
        case RECEIVE_ALL_TU_SEVICES:
            return { ...state, loadingServices: false, tuServices: action.tuServices };
        default:
            return state;
    }
}
